/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hassnaa Ayman",
  title: "Hi all, I'm Hassnaa",
  subTitle: emoji(
    "A passionate  Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nextjs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/10inGXzkMYqfvsdgMW29dmlHXnrXWQ-3Q/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/HassnaaAyman",
  linkedin: "https://www.linkedin.com/in/hassnaa-ayman-a8915912b/",
  gmail: "hassnaaayman16@gmail.com",
  facebook: "https://www.facebook.com/hassnaa.ayman.3/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY SOFTWARE DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Google Maps / Payment Gatways"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Typescript",
      fontAwesomeClassname: "fab fa-ts"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Graphql",
      fontAwesomeClassname: "fab fa-graphql"
    },
    {
      skillName: "nextjs",
      fontAwesomeClassname: "fab fa-next"
    },
    {
      skillName: "reactNative",
      fontAwesomeClassname: "fab fa-react-native"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "ITI - Information Technology Institute",
      logo: require("./assets/images/iti_logo.jpeg"),
      subHeader: "Diploma in Web and User Interface Development",
      duration: "October 2018 - Jun 2019",
      desc: "It is a 9-month program in web and use interface development track"
    },
    {
      schoolName: "Faculty Of Science",
      logo: require("./assets/images/facultyOfScience.jpeg"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2012 - Jun 2016",
      desc: "a four years of studing computer science"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Mobile",
      progressPercentage: "50%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Frontend Developer",
      company: "Delivering Creativity",
      companylogo: require("./assets/images/dc.jpeg"),
      date: "Dec 2020 – Present",
      desc: "I work on 2 projects the main website and the admin dashboard. the project is a service for any organization like companies , hotels , restaurants, ..etc.",
      descBullets: [
        "Responsible for the main website and the admin dashboard using reactjs.",
        "Develop new features and implement the UI from an exciting zeplin or xd.",
        "Integrate with 3rd party resources like Google Maps, Paytabs.",
        "Use new technologies like react query for caching requests,zustand as state management, styled-components, and Ant Design for the UI.",
        "Implement the SEO methodologies using react helmet and react snap",
        "Implement the optimization methods on our application like webpack bundle analyzer, why did you render, memorization using (memo, useMemo, and useCallback )",
        "Follow the Git flow from creating a branch to each new feature and do a pull request for it then a code review before getting merged.",
        "Finally, deploy on was s3 bucket and apply a ci/cd pipelines using GitLab."
      ]
    },
    {
      role: "Front-End Developer - Freelance",
      company: "Maison Pyramide",
      companylogo: require("./assets/images/maison-pyramide.jpeg"),
      date: "Jun 2021 – Nov 2021",
      desc: "Worked on an e-commerce for brands and showrooms",
      descBullets: [
        "Develop new features on an e-commerce platform using nextjs.",
        "Implement the UI from an exciting zeplin or xd and a design system.",
        "Develop/maintain our custom React component library and connect it to Storybook.",
        "Use new technologies chakra UI for the UI components.",
        "use Graphql.",
        "Follow the Git flow from creating a branch to each new feature and do a pull request for it then a code review before getting merged."
      ]
    },
    {
      role: "Frontend Developer",
      company: "Joovlly",
      companylogo: require("./assets/images/Joovlly.jpeg"),
      date: "Jun 2020 – Nov 2020",
      desc: "Worked on a CRM project",
      descBullets: [
        "Develop new features on a CRM project using nextjs.",
        "Implement the UI from an exciting zeplin or xd.",
        "Use new technologies like jest for unit testing, relay as a graphql client,custom webpack configuration with next and relay , service workers and indexedDB for the online and offline modes.",
        "Implement the optimization methods on our application like webpack bundle analyzer, why did you render, memorization using (memo, useMemo, and useCallback ) , dynamic imports, images optimization, virtual lists using react window."
      ]
    },
    {
      role: "Reactjs and React Native Developer",
      company: "Fudex",
      companylogo: require("./assets/images/fudex.jpeg"),
      date: "Jul 2019 – Jun 2020",
      desc: "Worked on a different projects like medical, e-commerce, mobile app",
      descBullets: [
        "Belsaa : mobile application consists of tasker and Employer about 85 screens I developed This application using react native, react hooks, typescript, and the UI from an existing xd.",
        "Qetaa : a website for selling the parts of cars and so on I developed it using reactjs, redux, react hooks, react element ui, Material UI , redux form, and the ui from an existing xd",
        "MacQueen: an e-commerce website about hotels reservation I developed it using react js, redux, react hooks, material UI, React element UI.",
        "Curawella Hospital: a medical website for letting patients reserve their Examination at the specific doctor I used in it react js, redux React localization,material UI, react element UI."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/logo.svg"),
      projectName: "Tdree",
      projectDesc:
        "A Service Website Helps your organization to get the right feedback",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://tdree.com/"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Npm Package",
      subtitle:
        "A Generator package helps us as a developers to generate the repetitive code or files",
      image: require("./assets/images/npm.png"),
      footerLink: [
        {
          name: "Generator",
          url: "https://www.npmjs.com/package/@hassnaa/generators-cli"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+(02) 01004345074",
  email_address: "hassnaaayman16@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
